module.exports = require("@bechtel/client-assets/dist/images/rod-room-edit-icon.svg");